import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, useMediaQuery, useTheme, CssBaseline, Paper, alpha } from '@mui/material';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { useThemeContext } from '../context/ThemeContext';

const MainLayout: React.FC = () => {
  const theme = useTheme();
  const { mode } = useThemeContext();
  const isDark = mode === 'dark';
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sidebarCollapsed, setSidebarCollapsed] = useState(isMobile);

  useEffect(() => {
    // Collapse sidebar automatically on mobile
    setSidebarCollapsed(isMobile);
  }, [isMobile]);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        height: '100vh',
        backgroundColor: theme.palette.background.default,
      }}
    >
      <CssBaseline />
      <Sidebar collapsed={sidebarCollapsed} />
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1, 
          display: 'flex', 
          flexDirection: 'column',
          overflowX: 'hidden',
          transition: 'margin-left 0.3s ease-in-out',
          marginLeft: 0,
        }}
      >
        <Topbar onMenuToggle={toggleSidebar} />
        <Box 
          sx={{ 
            flexGrow: 1, 
            p: { xs: 2, md: 3 }, 
            overflowY: 'auto',
            transition: 'all 0.3s ease',
            backgroundColor: theme.palette.background.default,
          }}
        >
          <Paper
            sx={{
              maxWidth: '100%',
              p: { xs: 2, md: 3 },
              borderRadius: 3,
              boxShadow: isDark 
                ? '0 4px 24px 0 rgba(0, 0, 0, 0.3)' 
                : '0 4px 24px 0 rgba(37, 99, 235, 0.06)',
              border: isDark 
                ? `1px solid ${alpha(theme.palette.primary.main, 0.1)}` 
                : `1px solid ${alpha(theme.palette.primary.main, 0.05)}`,
              backgroundColor: theme.palette.background.paper,
              mb: 4,
            }}
          >
            <Outlet />
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout;